import { SET_ACL } from './actions';

const initalState = {
    acl: {},
};

export const reducer = (state = initalState, action = {}) => {
    switch (action.type) {
        case SET_ACL: {
            return { ...state, acl: action.payload.acl };
        }
        default:
            return state;
    }
};

export default reducer;
